import moment from 'moment'

export const sheetNamePrefix = moment().format('YYYYMMDD')
